// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3XiPD"};